import { Avatar, Typography } from '../../designComponents';
import { InfoRowStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

type Props = {
  user: string;
  userName: string;
  email: string;
};

const ClientInformationHorizontal = ({ user, userName, email }: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="section-title"
        fontColor="secondary"
        strong
      >
        {user.toUpperCase()} INFORMATION
      </Typography>

      <InfoRowStyled className="jobInformation">
        <Typography className="title" fontColor="dark">
          Client Name :
        </Typography>
        <Avatar size="xsm" src={''} />
        <Typography fontColor="dark" className="value">
          {userName}
        </Typography>
      </InfoRowStyled>

      <InfoRowStyled className="jobInformation">
        <Typography className="title" fontColor="dark">
          Email Address :
        </Typography>
        <Typography className="value">{email}</Typography>
      </InfoRowStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default ClientInformationHorizontal;
